module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/filterWithAlertIcon-e8a9cc844a79393fe29f2a263c56a7a3.svg";